import SpriteSymbol from "../../../node_modules/.pnpm/registry.npmmirror.com+svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/registry.npmmirror.com+svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-next-to-right-icon",
  "use": "icon-next-to-right-icon-usage",
  "viewBox": "0 0 10 20",
  "content": "<symbol viewBox=\"0 0 10 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-next-to-right-icon\">\n<path d=\"M2.5 5L7.5 10L2.5 15\" stroke=\"black\" stroke-opacity=\"0.4\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol